import apiTrainerResults from '@/api/trainer-result'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  editTrainerResultStart: '[edit trainer result] Edit trainer result start',
  editTrainerResultSuccess: '[edit trainer result] Edit trainer result success',
  editTrainerResultFailure: '[edit trainer result] Edit trainer result failure',
}

export const actionTypes = {
  editTrainerResult: '[edit trainer result] Edit trainer result',
}

const mutations = {
  [mutationTypes.editTrainerResultStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.editTrainerResultSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.editTrainerResultFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.editTrainerResult](context, {id, trainerResultInput}) {
    context.commit(mutationTypes.editTrainerResultStart)
    return new Promise((resolve) => {
      apiTrainerResults
        .updateTrainerResult(id, trainerResultInput)
        .then((response) => {
          context.commit(mutationTypes.editTrainerResultSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.editTrainerResultFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
